/**
 * Heartbeat keeps the user's server session alive and triggers an event when it lapses.
 *  - Keep server session alive by pinging endpoint.
 *  - Ensure a minimum timeout is not exceeded (e.g. user loses connection causing the server session to elapse).
 *  - Ensure build ID doesn't change (e.g. during deployment)
 */

var _data;
var _timer;

/**
 * Ping heartbeat API endpoint.
 * 
 * @param {function} success    Callback function on success.
 * @param {function} error      Callback function on error.
 * @param {function} expired    Callback function when expired.
 */
function ping(success, error, expired) {

    var callback = function(fn) {
        if (typeof fn === 'function') fn();
    }

    $.ajax({
        method: 'GET',
        cache: false,
        url: '/api/heartbeat/',
        dataType: 'json',
        success: function(data) {

            let hasExpired = false;

            // check build hasn't changed.
            if (_data && _data.build !== data.build) {
                console.warn('Build changed');
                hasExpired = true;
            }

            // check elapsed time between heartbeats hasn't timed out.
            if (_data && new Date(data.now) - new Date(_data.now) > heartbeat.timeout) {
                console.warn('Timed out');
                hasExpired = true;
            }

            _data = data;

            if (hasExpired && typeof expired === 'function') { callback(expired); return; }

            if (hasExpired) { triggerExpiredEvent(); }

            callback(success);
        },
        error: function(e) {
            console.warn(e);
            callback(error);
        }
    });
}

/**
 * Start the heartbeat.
 */
function start() {

    stop();
    
    var callback = function() {
        _timer = setInterval(function(){
            ping();
        }, heartbeat.delay);
    }

    ping(callback, callback);
}


/**
 * Stop the heartbeat.
 */
function stop() {
    if (_timer) clearTimeout(_timer);
}

/**
 * Trigger the expired event on the window.
 */
function triggerExpiredEvent() {
    $(window).trigger('form-resync-required');
}

export const heartbeat = {
    delay: 1 * 60 * 1000,       // Interval between heartbeats.
    timeout: 15 * 60 * 1000,    // Heartbeat's client-side timeout (must be less than server's session timeout).
    start: start,
    stop: stop,
    ping: ping,
}
